module.exports = __webpack_public_path__ + "static/media/image-7.639ee226.jpg";